import { PERMISSION } from '../../login/permissions';
import { MobileNavActionItem } from './mobile-nav/mobile-nav.component';

/** What an entry may ask about the session — `TokenStorageService` answers both. */
export interface AccountSession {
  hasPermission(permission: string): boolean;
  isSuperuser(): boolean;
}

/** One account-menu entry: a page (`url`) or an action. One list, two renderers. */
export interface AccountMenuItem extends MobileNavActionItem {
  label: string;
  icon: string;
  visible: (session: AccountSession) => boolean;
}

export const ACCOUNT_MENU: readonly AccountMenuItem[] = [
  // C28: gated on a permission, never a role name.
  { label: 'USER_DROPDOWN.PROFILE', icon: 'cilUser', url: '/pages/profile',
    visible: (s) => s.hasPermission(PERMISSION.PROFILE_MANAGE) },
  { label: 'USER_DROPDOWN.TEAM', icon: 'cilPeople', url: '/pages/team',
    visible: (s) => s.hasPermission(PERMISSION.MEMBERS_MANAGE) },
  // C29: on the account kind — inside a tenant a superuser holds the owner's permissions.
  { label: 'USER_DROPDOWN.SWITCH_PROFILE', icon: 'cilSwapHorizontal', action: 'switch-profile',
    visible: (s) => s.isSuperuser() },
];

export function visibleAccountMenu(session: AccountSession): AccountMenuItem[] {
  return ACCOUNT_MENU.filter((item) => item.visible(session));
}
